var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isDetail)?_c('vxe-checkbox-group',_vm._g(_vm._b({},'vxe-checkbox-group',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2):_c('span',[_vm._v(_vm._s(_vm.formVal)+" ")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-1c7c75fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/form/checkGroup.vue
// module id = 325
// module chunks = 0 20